import { Controller } from "stimulus"

export default class extends Controller {
    static targets = ['handle', 'content']

    connect() {
        this.element.classList.add('collapsable')

        if (this.element.hasAttribute('data-collapsed')) {
            this.element.classList.add('collapsed')
        }

        this.handleTarget.classList.add('collapsable-handle')
        this.handleTarget.setAttribute('data-action', 'click->collapsable#toggle keydown->collapsable#toggle')
        this.handleTarget.setAttribute('tabindex', 0)

        this.contentTarget.classList.toggle('collapsable-content')
    }

    toggle(event) {
        if (event.type == 'keydown') {
            if (event.key == 'Enter') {
                event.preventDefault()
                this.element.classList.toggle('collapsed')
            }
        } else {
            event.preventDefault()
            this.element.classList.toggle('collapsed')
        }
    }
}
